const products = [
  {
    id: '1',
    image: '/assets/img/product_bread_3.jpg',
    alt: 'ラウンド食パン　メープル',
    category: 'おすすめ',
    title: 'ラウンド食パン メープル',
    description:
      'しっとりとした生地の中から、メープルのやさしい甘い香りが広がります。そのままでも、かるくトーストしても格別。',
  },
  {
    id: '2',
    image: '/assets/img/product_bread_5.jpg',
    alt: '牛肉たっぷりカレーパン',
    category: 'おすすめ',
    title: '牛肉たっぷりカレーパン',
    description:
      'カリッと揚がった衣をかじると、牛肉と香味野菜の深いコクと旨みがあふれます。子供から大人まで、大人気のKamando代表するItemです。',
  },
  {
    id: '3',
    image: '/assets/img/product_bread_1.jpg',
    alt: 'サクサクメロンパン',
    category: 'おすすめ',
    title: 'サクサクメロンパン',
    description:
      '時間がたっても、サクサクのクッキー生地のが、おいしさの秘密。表面はサクサク、中はふんわり。',
  },
]

export function Products() {
  return (
    <section id="products" className="products-section">
      <div className="container">
        <div className="products-asymmetric-grid">
          {products.map((product, index) => (
            <div
              key={product.id}
              className={`product-card product-card-${index + 1}`}
            >
              <img src={product.image} alt={product.alt} loading="lazy" />
              <div className="product-text">
                <div className="product-category">{product.category}</div>
                <h3>{product.title}</h3>
                <p>{product.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
